/** A cutscene's own effects (ui/cutscene.ts), over the figures. */
import { registerRenderPass } from './registry';

registerRenderPass({
  id: 'stage',
  layer: 'world',
  order: 200,
  draw(f) {
    f.renderer.stage?.draw?.(f.g, f.ox, f.oy, f.iso, f.world.time);
  },
});
